/**
 * JS port of snippets/cw-card-available-image.liquid
 * Same conservative Online Store card-image rule:
 * swap only when the current image is a variant.featured_image mapped
 * exclusively to unavailable color/variant keys AND another available
 * key has a featured_image. Never guess from filename, HEX, or alt.
 */
(function (window) {
  var COLOR_NAMES = { color: true, colour: true, colors: true };
  var SIZE_SUFFIX = /_(?:pico|icon|thumb|small|compact|medium|large|grande|master|1024x1024|\d+x\d*)\.(jpg|jpeg|png|webp|gif)$/i;

  function optionName(opt) {
    if (opt == null) return '';
    if (typeof opt === 'string') return opt;
    return String(opt.name || '');
  }

  function colorIndex(product) {
    var opts = (product && product.options) || [];
    var i;
    for (i = 0; i < opts.length; i++) {
      if (COLOR_NAMES[optionName(opts[i]).toLowerCase()]) return i;
    }
    return -1;
  }

  function variantKey(variant, index) {
    if (index === 0) return String(variant.option1);
    if (index === 1) return String(variant.option2);
    if (index === 2) return String(variant.option3);
    return String(variant.id);
  }

  function featuredSrc(image) {
    if (!image) return '';
    if (typeof image === 'string') return image;
    return image.src || image.url || '';
  }

  function featuredId(image) {
    if (!image || typeof image !== 'object') return '';
    return image.id != null ? String(image.id) : '';
  }

  function hasFeatured(image) {
    if (!image) return false;
    if (typeof image === 'string') return image.length > 0;
    return !!(image.id || image.src || image.url);
  }

  function normalizeSrc(url) {
    if (!url) return '';
    var s = String(url).split('?')[0].split('#')[0];
    s = s.replace(/^https?:/, '');
    s = s.replace(SIZE_SUFFIX, '.$1');
    return s.toLowerCase();
  }

  function sameImage(cardImage, variantImage) {
    if (!hasFeatured(cardImage) || !hasFeatured(variantImage)) return false;
    var ida = featuredId(cardImage);
    var idb = featuredId(variantImage);
    if (ida && idb) return ida === idb;
    return normalizeSrc(featuredSrc(cardImage)) === normalizeSrc(featuredSrc(variantImage));
  }

  function pickCardImage(product, currentImage) {
    var card = currentImage;
    if (!hasFeatured(card)) {
      if (hasFeatured(product.featured_image)) card = product.featured_image;
      else if (product.images && product.images.length) card = product.images[0];
    }

    var index = colorIndex(product);
    var variants = (product && product.variants) || [];
    var availKeys = '';
    var i;
    var key;
    var needle;
    var mapped = false;
    var keep = false;
    var picked = false;
    var v;
    var v2;
    var key2;

    for (i = 0; i < variants.length; i++) {
      if (variants[i].available) {
        availKeys += '|' + variantKey(variants[i], index) + '|';
      }
    }

    if (hasFeatured(card)) {
      for (i = 0; i < variants.length; i++) {
        v = variants[i];
        if (hasFeatured(v.featured_image) && sameImage(card, v.featured_image)) {
          mapped = true;
          needle = '|' + variantKey(v, index) + '|';
          if (availKeys.indexOf(needle) !== -1) keep = true;
        }
      }
    }

    if (mapped && !keep) {
      for (i = 0; i < variants.length && !picked; i++) {
        key = variantKey(variants[i], index);
        needle = '|' + key + '|';
        if (availKeys.indexOf(needle) === -1) continue;
        for (v2 = 0; v2 < variants.length && !picked; v2++) {
          key2 = variantKey(variants[v2], index);
          if (key2 === key && hasFeatured(variants[v2].featured_image)) {
            card = variants[v2].featured_image;
            picked = true;
          }
        }
      }
    }

    return card;
  }

  function featuredUrl(product, currentImage) {
    if (!product) return featuredSrc(currentImage);
    return featuredSrc(pickCardImage(product, currentImage || product.featured_image));
  }

  function writeProductImage(product, picked) {
    if (!product || !hasFeatured(picked)) return;
    var src = featuredSrc(picked);
    if (product.images && product.images.length) {
      if (typeof product.images[0] === 'string') product.images[0] = src;
      else if (product.images[0] && typeof product.images[0] === 'object') {
        if (typeof picked === 'object') {
          product.images[0] = picked;
        } else {
          product.images[0].src = src;
        }
      } else {
        product.images[0] = src;
      }
    }
    if (typeof product.featured_image === 'string') {
      product.featured_image = src;
    } else if (product.featured_image && typeof product.featured_image === 'object') {
      if (typeof picked === 'object') product.featured_image = picked;
      else product.featured_image.src = src;
    } else if (product.images && product.images.length) {
      product.featured_image = typeof product.images[0] === 'string' ? src : product.images[0];
    }
    if (typeof product.image === 'string') product.image = src;
  }

  function applyToProduct(product) {
    if (!product) return product;
    var current = product.images && product.images.length ? product.images[0] : product.featured_image;
    var picked = pickCardImage(product, current);
    if (picked && picked !== current) writeProductImage(product, picked);
    else if (picked && hasFeatured(picked) && !sameImage(current, picked)) writeProductImage(product, picked);
    return product;
  }

  function hookGlobo() {
    var g = window.globoRelatedProducts;
    if (!g || typeof g.buildBoxHTML !== 'function' || g._cwAvailHooked) {
      return !!(g && g._cwAvailHooked);
    }
    var orig = g.buildBoxHTML.bind(g);
    g.buildBoxHTML = function (box, products, cb) {
      var i;
      if (products && products.length) {
        for (i = 0; i < products.length; i++) applyToProduct(products[i]);
      }
      return orig(box, products, cb);
    };
    g._cwAvailHooked = true;
    return true;
  }

  function setElementImage(el, url) {
    if (!el || !url) return;
    if (el.tagName === 'IMG') {
      if (el.getAttribute('src') !== url) el.setAttribute('src', url);
    } else {
      el.style.backgroundImage = "url('" + url + "')";
    }
    el.setAttribute('data-cw-avail', '1');
  }

  var productCache = {};

  function fetchProduct(handle, cb) {
    if (!handle) return;
    if (productCache[handle]) {
      cb(productCache[handle]);
      return;
    }
    var req = new XMLHttpRequest();
    req.open('GET', '/products/' + encodeURIComponent(handle) + '.js', true);
    req.onreadystatechange = function () {
      var data;
      if (req.readyState !== 4) return;
      if (req.status < 200 || req.status >= 300) return;
      try {
        data = JSON.parse(req.responseText);
      } catch (err) {
        return;
      }
      productCache[handle] = data;
      cb(data);
    };
    req.send();
  }

  function handleFromNode(node) {
    var link = node.closest ? node.closest('a[href*="/products/"]') : null;
    var wrap;
    var match;
    if (!link) {
      wrap = node.closest ? node.closest('.ga-product, .ga-upsell-product, [id^="product-"]') : null;
      if (wrap) link = wrap.querySelector('a[href*="/products/"]');
    }
    if (!link) return '';
    match = String(link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function rewriteNode(node) {
    var handle;
    if (!node || node.nodeType !== 1 || node.getAttribute('data-cw-avail')) return;
    handle = handleFromNode(node);
    if (!handle) return;
    fetchProduct(handle, function (product) {
      var url = featuredUrl(product);
      if (url) setElementImage(node, url);
      else node.setAttribute('data-cw-avail', '1');
    });
  }

  function scanRoot(root) {
    var list;
    var i;
    if (!root || !root.querySelectorAll) return;
    if (root.matches && (root.matches('.ga-product_image, img[id^="ga-product_image_"], #recently-viewed-products img'))) {
      rewriteNode(root);
    }
    list = root.querySelectorAll('.ga-product_image, img[id^="ga-product_image_"], #recently-viewed-products img');
    for (i = 0; i < list.length; i++) rewriteNode(list[i]);
  }

  function observeDom() {
    if (!document || !document.documentElement) return;
    if (document.body) scanRoot(document.body);
    if (typeof MutationObserver === 'undefined') return;
    var obs = new MutationObserver(function (records) {
      var i;
      var rec;
      var j;
      for (i = 0; i < records.length; i++) {
        rec = records[i];
        if (rec.type === 'childList') {
          for (j = 0; j < rec.addedNodes.length; j++) scanRoot(rec.addedNodes[j]);
        } else if (rec.type === 'attributes' && rec.target) {
          rewriteNode(rec.target);
        }
      }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  var api = window.CWCardAvailable;
  if (!api) {
    api = {
      pickCardImage: pickCardImage,
      featuredUrl: featuredUrl,
      applyToProduct: applyToProduct,
      hookGlobo: hookGlobo
    };
    window.CWCardAvailable = api;
  }

  hookGlobo();
  if (!window.globoRelatedProducts || !window.globoRelatedProducts._cwAvailHooked) {
    var tries = 0;
    var timer;
    if (typeof window.setInterval === 'function') {
      timer = window.setInterval(function () {
        tries += 1;
        if (hookGlobo() || tries > 200) window.clearInterval(timer);
      }, 25);
    }
  }

  if (document && document.readyState === 'loading' && document.addEventListener) {
    document.addEventListener('DOMContentLoaded', observeDom);
  } else if (document) {
    observeDom();
  }
})(window);
